
const filterDataBySearch = (dataList: any[], search: string, keysToSearch: string[], setDataFn: React.Dispatch<any>) => {
    if(dataList && (dataList).length>0 ){
    const filteredData = dataList.filter((item: any) => {
        const searchMatch = !search || keysToSearch.some((key: any) =>
            {
                if( !item[key]){
                    return false;
                }
                return item[key].toLowerCase().includes(search.toLowerCase())
            }
           
        );
        return searchMatch;
    });

    setDataFn(filteredData);
}
};

export default filterDataBySearch;